/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Receipt_Open_CustomerInputs */



/**
* | output |
* | --- |
* | "Open customer" |
*
* @param {Partner_Receipt_Open_CustomerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_receipt_open_customer = /** @type {((inputs?: Partner_Receipt_Open_CustomerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Receipt_Open_CustomerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kunde öffnen")
	return /** @type {LocalizedString} */ ("Open customer")
});